module.exports = __webpack_public_path__ + "static/media/BCH-icon.8ea62e58.svg";